import * as yup from 'yup'

const schema = ({ isNew }) =>
  yup.object().shape({
    ...(isNew && {
      user: yup
        .object()
        .shape({
          id: yup.number().required(),
          name: yup.string().required(),
        })
        .required()
        .typeError('Preencha esse campo'),
    }),
    ...(isNew && {
      committeeRole: yup
        .object()
        .shape({
          id: yup.number().required(),
          name: yup.string().required(),
        })
        .required()
        .typeError('Preencha esse campo'),
    }),
  })

export default schema
